export default __webpack_public_path__ + "static/media/ic_el_salvador.afb5b9f8.svg";